<template>
  <div class="rb-ob-form rb-match-page rb-tx-page">
    <header>
      <h1 class="rb-ob-title">{{ title }}</h1>
    </header>

    <div class="rb-tx-panel">
      <p>{{ body }}</p>
    </div>

    <ul class="rb-tx-summary" :aria-label="$t('intake.treatment.missMetaAria')">
      <li>
        <span class="rb-tx-k">{{ $t('intake.treatment.missSession') }}</span>
        <span class="rb-tx-v">{{ sessionValue }}</span>
      </li>
      <li>
        <span class="rb-tx-k">{{ $t('intake.treatment.missForm') }}</span>
        <span class="rb-tx-v">{{ $t('intake.treatment.missFormValue') }}</span>
      </li>
    </ul>

    <div v-if="state === 'open'" class="rb-tx-choice-stack" role="radiogroup" :aria-label="$t('intake.treatment.missReasonAria')">
      <label v-for="opt in options" :key="opt">
        <input v-model="reason" type="radio" name="miss" :value="opt">
        <span>{{ $t('intake.treatment.missOpt_' + opt) }}</span>
      </label>
    </div>

    <div class="rb-ob-actions">
      <button v-if="state === 'open'" class="rb-ob-submit" type="button" @click="complete">
        {{ $t('intake.treatment.missComplete') }}
      </button>
      <button class="rb-ob-submit rb-ob-submit-secondary" type="button" @click="back">
        {{ $t('intake.treatment.missBack') }}
      </button>
      <p class="rb-ob-status" role="status" aria-live="polite">{{ loading ? $t('intake.portal.loading') : '' }}</p>
      <div class="rb-ob-trust">
        <p>{{ $t('intake.trustPath') }}</p>
        <p>{{ $t('authUi.familyNote') }}</p>
      </div>
    </div>
  </div>
</template>

<script>
import {fetchTreatmentAssessmentForm, hasAuthToken} from '@/intake/portalApi'

export default {
  name: 'AssessMissStep',
  data() {
    return {
      loading: true,
      form: null,
      state: 'unknown',
      reason: 'later',
      options: ['later', 'tech', 'skip'],
    }
  },
  computed: {
    requestedSessionId() {
      const raw = this.$route.query.sessionId
      return raw != null && String(raw).trim() !== '' ? String(raw) : ''
    },
    title() {
      if (this.state === 'skipped') return this.$t('intake.treatment.missSkippedTitle')
      if (this.state === 'open') return this.$t('intake.treatment.missTitle')
      return this.$t('intake.treatment.missUnknownBody')
    },
    body() {
      if (this.state === 'skipped') return this.$t('intake.treatment.missSkippedBody')
      if (this.state === 'open') return this.$t('intake.treatment.missBody')
      return this.$t('intake.treatment.missUnknownBody')
    },
    sessionValue() {
      if (this.form && this.form.sessionLabel && String(this.form.sessionId) === this.requestedSessionId) {
        return this.form.sessionLabel + ' · ' + this.requestedSessionId
      }
      return this.requestedSessionId || this.$t('intake.treatment.doneSessionUnknown')
    },
  },
  mounted() {
    this.load()
  },
  methods: {
    lang() {
      return this.$route.params.lang || 'fa'
    },
    load() {
      this.loading = true
      if (!hasAuthToken() || !this.requestedSessionId) {
        this.state = 'unknown'
        this.loading = false
        return
      }
      fetchTreatmentAssessmentForm(this.requestedSessionId, 'ORS')
          .then((form) => {
            this.form = form
            if (form && form.obligationStatus === 'skipped') this.state = 'skipped'
            else if (form && !form.completed) this.state = 'open'
            else this.state = 'unknown'
          })
          .catch(() => {
            this.form = null
            this.state = 'unknown'
          })
          .finally(() => {
            this.loading = false
          })
    },
    complete() {
      const query = this.requestedSessionId ? {sessionId: this.requestedSessionId} : {}
      this.$router.push({name: 'intakeOutcomeOrs', params: {lang: this.lang()}, query})
    },
    back() {
      this.$router.push({name: 'portalHome', params: {lang: this.lang()}})
    },
  },
}
</script>
